import React from 'react'; import ExtendedModulePage from './ExtendedModulePage'; export default function IdCardsPage(){return <ExtendedModulePage moduleKey="id-cards"/>}
